import { ReactNode } from 'react';
import cns from 'classnames';
import S from './Chip.module.scss';
const Chip = ({
  children,
  leftSlot,
  rightSlot,
  variant
}: ChipProps) => {
  return <div className={cns([S.wrapper, S[`chip_${variant}`]])} data-sentry-component="Chip" data-sentry-source-file="Chip.tsx">
      {leftSlot && <span className={S.slot}>{leftSlot}</span>}
      <span className={S.text}>{children}</span>
      {rightSlot && <span className={S.slot}>{rightSlot}</span>}
    </div>;
};
export default Chip;
type ChipProps = {
  children: string;
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
  variant: 'default' | 'primary' | 'alert';
};